import {
  CommandBarButton,
  ContextualMenu,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  ICommandBarStyles,
  IContextualMenuItem,
  IStackStyles,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  StackItem,
  Text,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";

import styles from "./ChatHistoryPanel.module.css";
import { useContext, useEffect, useState } from "react";
import { AppStateContext } from "../../state/AppProvider";
import React from "react";
import ChatHistoryList from "./ChatHistoryList";
import {
  ChatHistoryLoadingState,
  ChatMessage,
  Conversation,
  CosmosDBStatus,
  historyDeleteAll,
  historyRead,
  SingleConversation,
} from "../../api";
import { useNavigate } from "react-router-dom";
import { useAppLogo } from "../../hooks/useAppLogo";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import { Tooltip as ReactTooltip } from "react-tooltip";

interface ChatHistoryPanelProps {}

export enum ChatHistoryPanelTabs {
  History = "History",
}

const commandBarStyle: ICommandBarStyles = {
  root: {
    padding: "0",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
};

const commandBarButtonStyle: Partial<IStackStyles> = {
  root: { height: "50px" },
};

export function ChatHistoryPanel({ onNewChat }: { onNewChat: () => void }) {
  const navigate = useNavigate();
  const appLogo = useAppLogo();
  const appStateContext = useContext(AppStateContext);
  const [showContextualMenu, setShowContextualMenu] = React.useState(false);
  const [hideClearAllDialog, { toggle: toggleClearAllDialog }] =
    useBoolean(true);
  const [clearing, setClearing] = React.useState(false);
  const [clearingError, setClearingError] = React.useState(false);
  const [Opentoggle, setonpentoggle] = React.useState(false);
  const [toggleactive, setToggleActive] = React.useState(false);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
   const [searchTerm, setSearchTerm] = useState('');

  const handleBackClick = () => {
    navigate("/my-profile",);
  };

 
 const handleClearSearch=(()=>{
setSearchTerm("")
 })


  const clearAllDialogContentProps = {
    type: DialogType.close,
    title: !clearingError
      ? "Are you sure you want to clear all chat history?"
      : "Error deleting all of chat history",
    closeButtonAriaLabel: "Close",
    subText: !clearingError
      ? "All chat history will be permanently removed."
      : "Please try again. If the problem persists, please contact the site administrator.",
  };

  const modalProps = {
    titleAriaId: "labelId",
    subtitleAriaId: "subTextId",
    isBlocking: true,
    styles: { main: { maxWidth: 450 } },
  };

  const EditSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.24997 2.75003H1.74997C1.48475 2.75003 1.2304 2.85539 1.04286 3.04292C0.855326 3.23046 0.749969 3.48481 0.749969 3.75003V8.25003C0.749969 8.51525 0.855326 8.7696 1.04286 8.95714C1.2304 9.14467 1.48475 9.25003 1.74997 9.25003H6.24997C6.51519 9.25003 6.76954 9.14467 6.95708 8.95714C7.14461 8.7696 7.24997 8.51525 7.24997 8.25003V7.75003"
        stroke="#414143"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.94247 2.54252C9.13939 2.3456 9.25002 2.07851 9.25002 1.80002C9.25002 1.52153 9.13939 1.25445 8.94247 1.05752C8.74555 0.8606 8.47846 0.749969 8.19997 0.749969C7.92148 0.749969 7.65439 0.8606 7.45747 1.05752L3.24997 5.25002V6.75002H4.74997L8.94247 2.54252Z"
        stroke="#414143"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.74997 1.75003L8.24997 3.25003"
        stroke="#414143"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const DeleteSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 2H10V3H9V9.5C9 9.77615 8.77615 10 8.5 10H1.5C1.22386 10 1 9.77615 1 9.5V3H0V2H2.5V0.5C2.5 0.22386 2.72386 0 3 0H7C7.27615 0 7.5 0.22386 7.5 0.5V2ZM8 3H2V9H8V3ZM3.5 4.5H4.5V7.5H3.5V4.5ZM5.5 4.5H6.5V7.5H5.5V4.5ZM3.5 1V2H6.5V1H3.5Z"
        fill="#414143"
      />
    </svg>
  );

  const menuItems: IContextualMenuItem[] = [
    {
      key: "clearAll",
      text: "Clear all chat history",
      iconProps: { iconName: "Delete" },
    },
  ];

  const handleHistoryClick = () => {
    appStateContext?.dispatch({ type: "TOGGLE_CHAT_HISTORY" });
    setonpentoggle((prevState) => !prevState);
  };

  // const handleHistoryClick = () => {
  //   appStateContext?.dispatch({ type: "TOGGLE_CHAT_HISTORY" });
  //   setonpentoggle(prevState => !prevState)

  // };

  const onShowContextualMenu = React.useCallback(
    (ev: React.MouseEvent<HTMLElement>) => {
      ev.preventDefault(); // don't navigate
      setShowContextualMenu(true);
    },
    []
  );

  const onHideContextualMenu = React.useCallback(
    () => setShowContextualMenu(false),
    []
  );

  const onClearAllChatHistory = async () => {
    setClearing(true);
    let response = await historyDeleteAll();
    if (!response.ok) {
      setClearingError(true);
    } else {
      appStateContext?.dispatch({ type: "DELETE_CHAT_HISTORY" });
      toggleClearAllDialog();
    }
    setClearing(false);
  };

  const onHideClearAllDialog = () => {
    toggleClearAllDialog();
    setTimeout(() => {
      setClearingError(false);
    }, 2000);
  };

  React.useEffect(() => {}, [
    appStateContext?.state.chatHistory,
    clearingError,
  ]);

  const handelClick = () => {
    //console.log("testing")
    window.location.reload();
  };
  const convId: any = appStateContext?.state.currentChat?.id;

  // useEffect(() => {
  //   if (!convId) return;

  //   const fetchHistory = async () => {
  //     const response = await historyRead(convId);
  //     console.log("response", response);

  //     // appStateContext?.dispatch({
  //     //   type: "SINGLE_UPDATE_CURRENT_CHAT",
  //     // payload: response,
  //     // });
  //   };

  //   fetchHistory();
  // }, [convId]);

    const NewChatSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.264 0.812573C12.3473 -0.270858 14.104 -0.270858 15.1874 0.812573C16.2709 1.896 16.2709 3.65259 15.1874 4.73602L9.91028 10.0132C9.23033 10.6931 8.34826 11.1341 7.39633 11.2701L5.45863 11.5469C5.18168 11.5865 4.90226 11.4934 4.70444 11.2956C4.50662 11.0977 4.41348 10.8183 4.45304 10.5414L4.72986 8.60366C4.86585 7.65173 5.30691 6.76958 5.98684 6.08968L11.264 0.812573ZM13.9304 2.06955C13.5412 1.68034 12.9101 1.68034 12.5209 2.06955L7.24381 7.34669C6.83584 7.75466 6.57124 8.28386 6.48965 8.85502L6.38041 9.61959L7.14489 9.51035C7.71604 9.42876 8.24534 9.16415 8.65331 8.75618L13.9304 3.47904C14.3196 3.08982 14.3196 2.45878 13.9304 2.06955ZM7.11058 0.889385C7.11093 1.38026 6.71336 1.77851 6.22247 1.7789C5.33495 1.77959 4.70871 1.78619 4.2188 1.83274C3.73914 1.87831 3.45297 1.95764 3.23356 2.06944C2.73183 2.32508 2.32392 2.733 2.06827 3.23472C1.949 3.4688 1.86708 3.77784 1.82313 4.31572C1.77834 4.86399 1.77764 5.56821 1.77764 6.57848V9.42271C1.77764 10.4329 1.77834 11.1372 1.82313 11.6854C1.86708 12.2233 1.949 12.5323 2.06827 12.7664C2.32392 13.2681 2.73183 13.6761 3.23356 13.9317C3.46763 14.051 3.77667 14.1328 4.31456 14.1768C4.86282 14.2216 5.56704 14.2224 6.57729 14.2224H9.42152C10.4318 14.2224 11.136 14.2216 11.6843 14.1768C12.2221 14.1328 12.5311 14.051 12.7653 13.9317C13.267 13.6761 13.6749 13.2681 13.9305 12.7664C14.0423 12.547 14.1217 12.2608 14.1672 11.7812C14.2138 11.2913 14.2204 10.665 14.2211 9.77753C14.2214 9.28663 14.6197 8.88897 15.1106 8.88942C15.6015 8.88977 15.9991 9.28806 15.9987 9.77886C15.998 10.6483 15.9928 11.3611 15.9369 11.9493C15.8801 12.5478 15.7664 13.079 15.5144 13.5734C15.0884 14.4096 14.4085 15.0895 13.5723 15.5156C13.0459 15.7838 12.4768 15.8957 11.829 15.9485C11.1999 16 10.4229 16 9.45956 16H6.53924C5.57593 16 4.79897 16 4.1698 15.9485C3.52199 15.8957 2.95297 15.7838 2.42653 15.5156C1.59032 15.0895 0.910448 14.4096 0.484382 13.5734C0.216144 13.047 0.104321 12.478 0.051392 11.8302C-1.74679e-05 11.201 -8.65454e-06 10.4241 2.33681e-07 9.46075V6.54044C-8.65454e-06 5.57711 -1.74679e-05 4.80014 0.051392 4.17096C0.104321 3.52314 0.216144 2.95413 0.484382 2.42769C0.910448 1.59147 1.59032 0.911614 2.42653 0.485539C2.92096 0.233612 3.45218 0.119922 4.05067 0.0630644C4.63893 0.00717521 5.35163 0.00193114 6.22106 0.00125563C6.71194 0.000873437 7.11022 0.398497 7.11058 0.889385Z"
        fill="currentColor"
      />
    </svg>
  );

  const sideBarEnable = appStateContext?.state.isChatHistoryOpen;

  return (
    <section
      className={`${styles.container} ${
        sideBarEnable ? styles.chatHistory_Active : ""
      } `}
      data-is-scrollable
      aria-label={"chat history panel"}
    >
      <div className={styles.sidebarListItemLogo}>
        <a href="javascript:void()">
          {appLogo ? (
            <img
              src={appLogo}
              alt="Lipi logo"
              className={styles.customSidebarLogo}
            />
          ) : (
          <svg
            width="42"
            height="24"
            viewBox="0 0 58 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path id="logopath1"
              d="M55.0589 4.27963C54.4429 4.27963 53.9133 4.0797 53.4702 3.67984C53.0379 3.27997 52.8218 2.77204 52.8218 2.15603C52.8218 1.54002 53.0379 1.02668 53.4702 0.616008C53.9133 0.205336 54.4429 0 55.0589 0C55.6965 0 56.2368 0.205336 56.6799 0.616008C57.123 1.02668 57.3446 1.54002 57.3446 2.15603C57.3446 2.73961 57.123 3.24215 56.6799 3.66363C56.2368 4.0743 55.6965 4.27963 55.0589 4.27963ZM56.9231 22.4843C56.9231 23.5228 56.0812 24.3647 55.0426 24.3647C54.0041 24.3647 53.1622 23.5228 53.1622 22.4843V9.64539C53.1622 8.60684 54.0041 7.76494 55.0426 7.76494C56.0812 7.76494 56.9231 8.60684 56.9231 9.64538V22.4843Z"
              
            />
            <path id="logopath2"
              d="M37.2763 21.3745C37.2683 21.3616 37.2541 21.3535 37.2389 21.3535C37.2148 21.3535 37.1952 21.3731 37.1952 21.3973V30.0221C37.1952 31.1145 36.3096 32 35.2173 32C34.1249 32 33.2393 31.1144 33.2393 30.0221V8.38873C33.2393 7.29634 34.1249 6.4108 35.2173 6.4108H35.6547C36.5055 6.4108 37.1952 7.1005 37.1952 7.95128V9.44848C37.1952 9.47239 37.2146 9.49177 37.2385 9.49177C37.2539 9.49177 37.2682 9.48341 37.276 9.47009C38.6284 7.1567 40.6021 6 43.1972 6C45.4138 6 47.1417 6.78165 48.3807 8.34496C49.6198 9.90827 50.2393 12.0079 50.2393 14.6438C50.2393 17.5651 49.5402 19.9043 48.142 21.6616C46.7438 23.4189 44.8341 24.2976 42.4128 24.2976C40.1928 24.2976 38.4806 23.3232 37.2763 21.3745ZM37.1611 14.4384V16.6122C37.1611 17.8903 37.5646 18.9743 38.3717 19.8644C39.1902 20.7544 40.2246 21.1995 41.475 21.1995C42.9414 21.1995 44.0895 20.6289 44.9194 19.4878C45.7605 18.3353 46.1811 16.7321 46.1811 14.6781C46.1811 12.955 45.789 11.6085 45.0046 10.6386C44.2316 9.65723 43.1801 9.16656 41.8502 9.16656C40.4406 9.16656 39.3038 9.66864 38.4399 10.6728C37.5874 11.677 37.1611 12.9322 37.1611 14.4384Z"
              fill="#0D0D0D"
            />
            <path id="logopath3"
              d="M25.9636 23.0058C25.9623 22.9454 25.9369 22.8879 25.8925 22.8452C25.8481 22.8025 25.7882 22.778 25.7254 22.7768L18.6226 22.7775C18.617 22.7775 18.6123 22.7745 18.6067 22.7745C18.5738 22.7726 18.5413 22.767 18.5098 22.7577C18.4886 22.7538 18.4678 22.7484 18.4475 22.7413C18.418 22.7269 18.3904 22.7091 18.3653 22.6882C18.3486 22.6776 18.3327 22.6659 18.3177 22.6531C18.2957 22.6284 18.2766 22.6014 18.2609 22.5726C18.2503 22.5569 18.2407 22.5406 18.2324 22.5237C18.2296 22.5172 18.222 22.5138 18.2212 22.5054L16.095 16.4468C15.987 16.0827 15.9708 15.699 16.0478 15.3277C16.1248 14.9563 16.2927 14.608 16.5376 14.3114L21.3062 8.54369C21.4474 8.37108 21.6283 8.2322 21.8346 8.13792C22.0409 8.04364 22.2671 7.99651 22.4956 8.0002L22.4979 8.00249L22.5003 8.0002L22.5087 8.00211C22.7074 7.99972 22.9047 8.03565 23.0888 8.10775C23.2729 8.17986 23.4401 8.28669 23.5805 8.42194C23.6215 8.46137 23.6601 8.50304 23.696 8.54675L28.4638 14.313C28.7101 14.6124 28.8782 14.9642 28.9541 15.3389C29.03 15.7136 29.0115 16.1003 28.9001 16.4667L27.8977 19.3235C27.8803 19.3742 27.8527 19.4211 27.8163 19.4615C27.78 19.5019 27.7357 19.535 27.6861 19.5588C27.6364 19.5827 27.5823 19.5969 27.5269 19.6006C27.4715 19.6043 27.4159 19.5974 27.3632 19.5803C27.3106 19.5632 27.262 19.5363 27.2202 19.5011C27.1785 19.4659 27.1444 19.4231 27.1199 19.3752C27.0954 19.3273 27.081 19.2752 27.0776 19.2219C27.0741 19.1686 27.0817 19.1152 27.0998 19.0647L28.0962 16.2259C28.1674 15.9856 28.1781 15.7326 28.1273 15.4876C28.0766 15.2426 27.9659 15.0128 27.8044 14.8171L23.0414 9.04787C23.007 9.00751 22.9677 8.97125 22.9243 8.93986V14.1122C23.4502 14.2126 23.9185 14.4976 24.238 14.9116C24.5575 15.3256 24.7054 15.8391 24.6529 16.3521C24.6004 16.8651 24.3513 17.3411 23.954 17.6873C23.5567 18.0335 23.0397 18.2253 22.5035 18.2253C21.9673 18.2253 21.4503 18.0335 21.053 17.6873C20.6557 17.3411 20.4066 16.8651 20.3541 16.3521C20.3016 15.8391 20.4495 15.3256 20.769 14.9116C21.0885 14.4976 21.5568 14.2126 22.0827 14.1122L22.0823 8.93872C22.0391 8.97068 22.0004 9.00788 21.9672 9.0494L17.1978 14.8141C17.0377 15.0072 16.9273 15.2339 16.8758 15.4758C16.8243 15.7177 16.833 15.968 16.9013 16.206L18.9259 21.9692L25.727 21.9669C25.8688 21.9668 26.0092 21.9935 26.1402 22.0456C26.2712 22.0977 26.3903 22.1742 26.4905 22.2706C26.5908 22.367 26.6703 22.4814 26.7245 22.6074C26.7787 22.7333 26.8065 22.8683 26.8064 23.0046L26.8068 24.9599C26.8067 25.2352 26.6929 25.4992 26.4904 25.6939C26.2879 25.8885 26.0134 25.9979 25.727 25.998L16.8519 25.9999C16.796 26.0009 16.7405 25.9911 16.6885 25.9712C16.6366 25.9513 16.5893 25.9217 16.5494 25.884C16.5095 25.8464 16.4778 25.8015 16.4562 25.7519C16.4345 25.7023 16.4233 25.6491 16.4233 25.5954C16.4233 25.5416 16.4344 25.4884 16.456 25.4388C16.4776 25.3892 16.5092 25.3443 16.5491 25.3066C16.589 25.2689 16.6362 25.2392 16.6881 25.2193C16.7401 25.1993 16.7956 25.1895 16.8515 25.1904L25.7266 25.19C25.7579 25.1902 25.789 25.1844 25.818 25.1729C25.8469 25.1615 25.8733 25.1446 25.8954 25.1233C25.9176 25.102 25.9351 25.0767 25.947 25.0489C25.9589 25.021 25.965 24.9912 25.9648 24.961L25.9636 23.0058ZM21.575 17.0354C21.7586 17.2119 21.9926 17.3322 22.2473 17.3809C22.502 17.4296 22.7661 17.4046 23.006 17.309C23.246 17.2135 23.4511 17.0517 23.5953 16.8441C23.7396 16.6364 23.8167 16.3924 23.8167 16.1427C23.8167 15.893 23.7396 15.6489 23.5953 15.4413C23.4511 15.2336 23.246 15.0718 23.006 14.9763C22.7661 14.8807 22.502 14.8557 22.2473 14.9044C21.9926 14.9531 21.7586 15.0734 21.575 15.2499C21.329 15.4868 21.1908 15.8079 21.1908 16.1427C21.1908 16.4774 21.329 16.7985 21.575 17.0354Z"
              fill="#DA2128"
              stroke="#DA2128"
              stroke-width="0.9"
            />
            <circle id="logopathcircle" cx="23.2471" cy="2.24705" r="2.24705" fill="#DA2128" />
            <path id="logopath5"
              d="M14 25.2513C14 26.2171 13.2171 27 12.2513 27H2C0.895431 27 0 26.1046 0 25V2C0 0.895431 0.895431 0 2 0H2.19647C3.30104 0 4.19647 0.895431 4.19647 2V21.5026C4.19647 22.6071 5.0919 23.5026 6.19647 23.5026H12.2513C13.2171 23.5026 14 24.2855 14 25.2513Z"
              fill="#0D0D0D"
            />
          </svg>
          )}
        </a>
        <button
                className="newChat"
                data-tooltip-id="newChat"
               onClick={onNewChat}   
              >
                <i>
                  <NewChatSvg />
                </i> <span>New Chat</span>
              </button>

              <div id="expand" style={{position:"absolute",right:" -1px",top: "0px"}}>
                  <button className="topExpandCollapse" id="expand-collapse-icon" onClick={handleHistoryClick}
                data-tooltip-id="sidebar-expandCollapse-tooltip"
                data-tooltip-content={sideBarEnable ? 'Expand' : 'Collapse '}>

                {sideBarEnable ? (
                  // Expanded Sidebar Icon

                  <i>
                    <svg id="expandedIcon"
                      width="16"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.4254 2.42563C14.4254 1.98381 14.0671 1.62563 13.6254 1.62563H2.42539C1.98356 1.62563 1.62539 1.98381 1.62539 2.42563V13.6256C1.62539 14.0674 1.98357 14.4256 2.42539 14.4256H13.6254C14.0671 14.4256 14.4254 14.0674 14.4254 13.6256V2.42563ZM16.0254 13.6256C16.0254 14.951 14.9508 16.0256 13.6254 16.0256H2.42539C1.0999 16.0256 0.0253906 14.951 0.0253906 13.6256V2.42563C0.0253906 1.10015 1.09991 0.0256348 2.42539 0.0256348H13.6254C14.9508 0.0256348 16.0254 1.10014 16.0254 2.42563V13.6256Z" fill="#202939" />
                      <path d="M4.8252 15.2256V0.825635C4.8252 0.383808 5.18337 0.0256348 5.6252 0.0256348C6.06702 0.0256348 6.4252 0.383808 6.4252 0.825635V15.2256C6.4252 15.6675 6.06702 16.0256 5.6252 16.0256C5.18337 16.0256 4.8252 15.6675 4.8252 15.2256Z" fill="#202939" />
                      <path d="M9.06048 5.06011C9.35338 4.76722 9.81658 4.74915 10.1308 5.00543L10.1917 5.06011L12.5917 7.46011C12.7418 7.61014 12.8261 7.81357 12.8261 8.02574C12.8261 8.23791 12.7418 8.44134 12.5917 8.59136L10.1917 10.9914C9.87932 11.3038 9.3729 11.3038 9.06048 10.9914C8.74807 10.6789 8.74807 10.1725 9.06048 9.86011L10.8949 8.02574L9.06048 6.19136L9.0058 6.13043C8.74952 5.81621 8.76759 5.35301 9.06048 5.06011Z" fill="#202939" />
                    </svg>
                  </i>




                ) : (
                  <i>

                    <svg id="collapsedIcon"
                      width="16"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.4254 2.45762C14.4254 2.0158 14.0671 1.65762 13.6254 1.65762H2.42539C1.98356 1.65762 1.62539 2.01579 1.62539 2.45762V13.6576C1.62539 14.0994 1.98357 14.4576 2.42539 14.4576H13.6254C14.0671 14.4576 14.4254 14.0994 14.4254 13.6576V2.45762ZM16.0254 13.6576C16.0254 14.983 14.9508 16.0576 13.6254 16.0576H2.42539C1.0999 16.0576 0.0253906 14.983 0.0253906 13.6576V2.45762C0.0253906 1.13213 1.09991 0.0576172 2.42539 0.0576172H13.6254C14.9508 0.0576172 16.0254 1.13213 16.0254 2.45762V13.6576Z" fill="#202939" />
                      <path d="M4.8252 15.2576V0.857617C4.8252 0.415791 5.18337 0.0576172 5.6252 0.0576172C6.06702 0.0576172 6.4252 0.415791 6.4252 0.857617V15.2576C6.4252 15.6994 6.06702 16.0576 5.6252 16.0576C5.18337 16.0576 4.8252 15.6994 4.8252 15.2576Z" fill="#202939" />
                      <path d="M12.5919 5.0921C12.299 4.79921 11.8358 4.78113 11.5215 5.03741L11.4606 5.0921L9.06061 7.4921C8.91058 7.64213 8.82623 7.84555 8.82623 8.05772C8.82623 8.2699 8.91058 8.47332 9.06061 8.62335L11.4606 11.0233C11.773 11.3358 12.2794 11.3358 12.5919 11.0233C12.9043 10.7109 12.9043 10.2045 12.5919 9.8921L10.7575 8.05772L12.5919 6.22335L12.6465 6.16241C12.9028 5.84819 12.8847 5.38499 12.5919 5.0921Z" fill="#202939" />
                    </svg>
                  </i>



                )}

              </button>

              <ReactTooltip
                id="sidebar-expandCollapse-tooltip"
                place="bottom"
                className={styles.customTooltip}
              />
              </div>
      </div>

      {/* <div className={styles.sidebarListItem}>
          <a href="javascript:void()" onClick={handelClick} >
            <i><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.264 0.812573C12.3473 -0.270858 14.104 -0.270858 15.1874 0.812573C16.2709 1.896 16.2709 3.65259 15.1874 4.73602L9.91028 10.0132C9.23033 10.6931 8.34826 11.1341 7.39633 11.2701L5.45863 11.5469C5.18168 11.5865 4.90226 11.4934 4.70444 11.2956C4.50662 11.0977 4.41348 10.8183 4.45304 10.5414L4.72986 8.60366C4.86585 7.65173 5.30691 6.76958 5.98684 6.08968L11.264 0.812573ZM13.9304 2.06955C13.5412 1.68034 12.9101 1.68034 12.5209 2.06955L7.24381 7.34669C6.83584 7.75466 6.57124 8.28386 6.48965 8.85502L6.38041 9.61959L7.14489 9.51035C7.71604 9.42876 8.24534 9.16415 8.65331 8.75618L13.9304 3.47904C14.3196 3.08982 14.3196 2.45878 13.9304 2.06955ZM7.11058 0.889385C7.11093 1.38026 6.71336 1.77851 6.22247 1.7789C5.33495 1.77959 4.70871 1.78619 4.2188 1.83274C3.73914 1.87831 3.45297 1.95764 3.23356 2.06944C2.73183 2.32508 2.32392 2.733 2.06827 3.23472C1.949 3.4688 1.86708 3.77784 1.82313 4.31572C1.77834 4.86399 1.77764 5.56821 1.77764 6.57848V9.42271C1.77764 10.4329 1.77834 11.1372 1.82313 11.6854C1.86708 12.2233 1.949 12.5323 2.06827 12.7664C2.32392 13.2681 2.73183 13.6761 3.23356 13.9317C3.46763 14.051 3.77667 14.1328 4.31456 14.1768C4.86282 14.2216 5.56704 14.2224 6.57729 14.2224H9.42152C10.4318 14.2224 11.136 14.2216 11.6843 14.1768C12.2221 14.1328 12.5311 14.051 12.7653 13.9317C13.267 13.6761 13.6749 13.2681 13.9305 12.7664C14.0423 12.547 14.1217 12.2608 14.1672 11.7812C14.2138 11.2913 14.2204 10.665 14.2211 9.77753C14.2214 9.28663 14.6197 8.88897 15.1106 8.88942C15.6015 8.88977 15.9991 9.28806 15.9987 9.77886C15.998 10.6483 15.9928 11.3611 15.9369 11.9493C15.8801 12.5478 15.7664 13.079 15.5144 13.5734C15.0884 14.4096 14.4085 15.0895 13.5723 15.5156C13.0459 15.7838 12.4768 15.8957 11.829 15.9485C11.1999 16 10.4229 16 9.45956 16H6.53924C5.57593 16 4.79897 16 4.1698 15.9485C3.52199 15.8957 2.95297 15.7838 2.42653 15.5156C1.59032 15.0895 0.910448 14.4096 0.484382 13.5734C0.216144 13.047 0.104321 12.478 0.051392 11.8302C-1.74679e-05 11.201 -8.65454e-06 10.4241 2.33681e-07 9.46075V6.54044C-8.65454e-06 5.57711 -1.74679e-05 4.80014 0.051392 4.17096C0.104321 3.52314 0.216144 2.95413 0.484382 2.42769C0.910448 1.59147 1.59032 0.911614 2.42653 0.485539C2.92096 0.233612 3.45218 0.119922 4.05067 0.0630644C4.63893 0.00717521 5.35163 0.00193114 6.22106 0.00125563C6.71194 0.000873437 7.11022 0.398497 7.11058 0.889385Z" fill="currentColor"></path></svg></i>
            New chat
          </a>
      </div> */}

      {/*<div className={styles.sidebarListItem}>
      
       <Stack className="SelectModal">
                <DropdownAi />
              </Stack> */}
      {/* <a href="javascript:void()">
          <i>          
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.15385 0C3.75385 0 1.84615 1.83704 1.84615 4.14815C1.84615 5.59259 2.59075 6.85127 3.73558 7.59259C1.54462 8.50212 0 10.6036 0 13.037H1.23077C1.23077 10.4296 3.44615 8.2963 6.15385 8.2963C8.55385 8.2963 10.4615 6.45926 10.4615 4.14815C10.4615 1.83704 8.55385 0 6.15385 0ZM6.15385 1.18519C7.87692 1.18519 9.23077 2.48889 9.23077 4.14815C9.23077 5.80741 7.87692 7.11111 6.15385 7.11111C4.43077 7.11111 3.07692 5.80741 3.07692 4.14815C3.07692 2.48889 4.43077 1.18519 6.15385 1.18519ZM11.1382 7.7037V8.94792C10.769 9.00718 10.4002 9.18565 10.0925 9.36343L9.16947 8.47454L8.30769 9.30324L9.23077 10.1921C8.98462 10.4884 8.86202 10.8444 8.80048 11.2593H7.38462V12.4444H8.67668C8.73822 12.8 8.92356 13.156 9.10817 13.5116L8.1851 14.4005L9.04567 15.2292L9.96875 14.3403C10.2764 14.5181 10.6464 14.6965 11.0156 14.7558V16H12.2464V14.7558C12.6156 14.6965 12.9844 14.5181 13.2921 14.3403L14.2151 15.2292L15.0769 14.4005L14.1538 13.5116C14.4 13.2153 14.5226 12.8593 14.5841 12.4444H16V11.2593H14.7079C14.6464 10.9037 14.4611 10.5477 14.2764 10.1921L15.1995 9.30324L14.3389 8.47454L13.4159 9.36343C13.1082 9.18565 12.7382 9.00718 12.369 8.94792V7.7037H11.1382ZM11.6923 10.0741C12.7385 10.0741 13.5385 10.8444 13.5385 11.8519C13.5385 12.8593 12.7385 13.6296 11.6923 13.6296C10.6462 13.6296 9.84615 12.8593 9.84615 11.8519C9.84615 10.8444 10.6462 10.0741 11.6923 10.0741ZM11.6923 11.2593C11.6154 11.2593 11.5385 11.2778 11.4663 11.3102C11.3942 11.3426 11.3269 11.3889 11.2692 11.4444C11.2115 11.5 11.1635 11.5648 11.1298 11.6343C11.0962 11.7037 11.0769 11.7778 11.0769 11.8519C11.0769 12.0741 11.25 12.2963 11.4663 12.3935C11.5385 12.4259 11.6154 12.4444 11.6923 12.4444C12 12.4444 12.3077 12.1481 12.3077 11.8519C12.3077 11.5556 12 11.2593 11.6923 11.2593Z" fill="currentColor"/>
          </svg>
          </i>{" "}
          Lipi Models
        </a> 
      </div> */}
      {/* <div className={styles.sidebarListItem}>
        <a href="javascript:void()">
          <i>          
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.15385 0C3.75385 0 1.84615 1.83704 1.84615 4.14815C1.84615 5.59259 2.59075 6.85127 3.73558 7.59259C1.54462 8.50212 0 10.6036 0 13.037H1.23077C1.23077 10.4296 3.44615 8.2963 6.15385 8.2963C8.55385 8.2963 10.4615 6.45926 10.4615 4.14815C10.4615 1.83704 8.55385 0 6.15385 0ZM6.15385 1.18519C7.87692 1.18519 9.23077 2.48889 9.23077 4.14815C9.23077 5.80741 7.87692 7.11111 6.15385 7.11111C4.43077 7.11111 3.07692 5.80741 3.07692 4.14815C3.07692 2.48889 4.43077 1.18519 6.15385 1.18519ZM11.1382 7.7037V8.94792C10.769 9.00718 10.4002 9.18565 10.0925 9.36343L9.16947 8.47454L8.30769 9.30324L9.23077 10.1921C8.98462 10.4884 8.86202 10.8444 8.80048 11.2593H7.38462V12.4444H8.67668C8.73822 12.8 8.92356 13.156 9.10817 13.5116L8.1851 14.4005L9.04567 15.2292L9.96875 14.3403C10.2764 14.5181 10.6464 14.6965 11.0156 14.7558V16H12.2464V14.7558C12.6156 14.6965 12.9844 14.5181 13.2921 14.3403L14.2151 15.2292L15.0769 14.4005L14.1538 13.5116C14.4 13.2153 14.5226 12.8593 14.5841 12.4444H16V11.2593H14.7079C14.6464 10.9037 14.4611 10.5477 14.2764 10.1921L15.1995 9.30324L14.3389 8.47454L13.4159 9.36343C13.1082 9.18565 12.7382 9.00718 12.369 8.94792V7.7037H11.1382ZM11.6923 10.0741C12.7385 10.0741 13.5385 10.8444 13.5385 11.8519C13.5385 12.8593 12.7385 13.6296 11.6923 13.6296C10.6462 13.6296 9.84615 12.8593 9.84615 11.8519C9.84615 10.8444 10.6462 10.0741 11.6923 10.0741ZM11.6923 11.2593C11.6154 11.2593 11.5385 11.2778 11.4663 11.3102C11.3942 11.3426 11.3269 11.3889 11.2692 11.4444C11.2115 11.5 11.1635 11.5648 11.1298 11.6343C11.0962 11.7037 11.0769 11.7778 11.0769 11.8519C11.0769 12.0741 11.25 12.2963 11.4663 12.3935C11.5385 12.4259 11.6154 12.4444 11.6923 12.4444C12 12.4444 12.3077 12.1481 12.3077 11.8519C12.3077 11.5556 12 11.2593 11.6923 11.2593Z" fill="currentColor"/>
          </svg>
          </i>{" "}
          My Profile
        </a>
      </div>  */}

      {/* <div className={styles.sidebarListItem}>
          <a href="javascript:void()">
            <i><svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.96207 9.84252C5.96207 10.3066 6.33909 10.6829 6.80418 10.6829C7.26926 10.6829 7.64629 10.3066 7.64629 9.84252V5.80884C7.64629 5.34473 7.26926 4.96851 6.80418 4.96851C6.33909 4.96851 5.96207 5.34473 5.96207 5.80884V9.84252Z" fill="currentColor"></path><path d="M6.05453 3.76366C6.05453 4.22777 6.43156 4.604 6.89665 4.604C7.36173 4.604 7.73876 4.22777 7.73876 3.76366V3.57278C7.73876 3.10868 7.36173 2.73245 6.89665 2.73245C6.43156 2.73245 6.05453 3.10868 6.05453 3.57278V3.76366Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.77895C0 1.24418 1.24158 0 2.77314 0H10.8404C12.372 0 13.6135 1.24418 13.6135 2.77895V11.7895H13.6168V13.3052C13.4698 13.3052 13.3922 13.356 13.3371 13.4232C13.2695 13.5056 13.2021 13.6616 13.2021 13.8947C13.2021 14.2203 13.4655 14.4841 13.7903 14.4841V16H2.10086C0.940598 16 2.50732e-05 15.0574 0 13.8948V2.77895ZM12.101 2.77895V11.7895H2.10086C1.89667 11.7895 1.69928 11.8187 1.51262 11.8731V2.77895C1.51262 2.08133 2.07697 1.51579 2.77314 1.51579H10.8404C11.5366 1.51579 12.101 2.08133 12.101 2.77895ZM1.51262 13.8947C1.51262 13.5692 1.77599 13.3052 2.10086 13.3052H11.7576C11.7115 13.4981 11.6894 13.6969 11.6894 13.8947C11.6894 14.0993 11.7186 14.2972 11.7729 14.4841H2.10086C1.776 14.4841 1.51264 14.2203 1.51262 13.8947Z" fill="currentColor"></path></svg></i>
            Guide
          </a>
      </div> */}

      {/* <div className={styles.sidebarListItem}>
          <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-model"
        >
          <Typography component="span"><i style={{width:"16px",marginRight:"8px"}}><svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 15 15" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z" fill="currentColor"></path></svg></i>Models</Typography>
        </AccordionSummary>
        <AccordionDetails>
        
          <div className={styles.modelBoxWrapper}>
            <div className={styles.modelOption_content}>
              <div className={styles.modelOption_content_title}><span>GPT4oMini</span>
              <span className={styles.tokens}>100000 tokens per day </span></div><span><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"></path></svg></span></div>

              </div>
        </AccordionDetails>
      </Accordion>
      </div> */}

      {/* chat history header start */}
      {/* <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        wrap
        aria-label="chat history header"
        className={styles.chatHistoryTextPanel}
        
      >
        <StackItem style={{ padding:"8px" }}>
          <Text
            role="heading"
            aria-level={2}
            style={{
              alignSelf: "center",
              fontWeight: "600",
              fontSize: "14px",
              marginRight: "auto",
              color: "#da2129",
            }}
          >
            Chat history
          </Text>
        </StackItem>
        <Stack verticalAlign="start">
          <Stack horizontal>
           
            <button className={styles.chateditsvg}>
              <i>
                <EditSvg />
              </i>
            </button>

            <ContextualMenu
              items={menuItems}
              hidden={!showContextualMenu}
              target={"#moreButton"}
              onItemClick={toggleClearAllDialog}
              onDismiss={onHideContextualMenu}
            />
          

            <button className={styles.chatdeltesvg}>
              <i>
                <DeleteSvg />
              </i>
            </button>
          </Stack>
        </Stack>
      </Stack> */}
      {/* chat history header start */}

      {/* chat history search start */}
      <div className={styles.historySearchFilterWrapper}>
        <div className={styles.searchHistory}>
        <i className={styles.searchIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"  height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"></path>
        </svg>
        </i>
        {searchTerm &&(
        <i className={styles.searchCancel} onClick={handleClearSearch}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
        </i>
        )}
        <input type="text" placeholder="Search"   value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
      </div>
      <button className={styles.historyfilter_btn}>
        <i><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"></path></svg></i>
      </button>
      </div>
      
       {/* chat history search start */}


      <Stack
        aria-label="chat history panel content"
        styles={{
          root: {
            display: "flex",
            flexGrow: 1,
            flexDirection: "column",
            paddingTop: "2.5px",
            maxWidth: "100%",
          },
        }}
        style={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          // flexWrap: "wrap",
          padding: "1px",
          position: "relative",
          paddingBottom: "56px",
          // height: "calc(100vh - 198px)",
          // height: "calc(100vh - 116px)",
          height: "calc(100vh - 108px)",
          marginTop: "16px",
        }}
      >
        {/* //collapse btn */}

        {/* {appStateContext?.state.isCosmosDBAvailable?.status !==
          CosmosDBStatus.NotConfigured && (
            <button
              className={styles.sidebarToggleBtn}
              onClick={handleHistoryClick}

              //@ts-ignore
              text={
                appStateContext?.state?.isChatHistoryOpen
                  ? "Hide chat history"
                  : "Show chat history"
              }
            >
              <i>
                <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 15 15" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z" fill="currentColor"></path></svg>
              </i>
            </button>

          )} */}

        {/* <button className={styles.LoadMore}> 
  <i>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5001 3.44338C12.1907 3.26474 11.8095 3.26474 11.5001 3.44338L4.83984 7.28868C4.53044 7.46731 4.33984 7.79744 4.33984 8.1547V15.8453C4.33984 16.2026 4.53044 16.5327 4.83984 16.7113L11.5001 20.5566C11.8095 20.7353 12.1907 20.7353 12.5001 20.5566L19.1604 16.7113C19.4698 16.5327 19.6604 16.2026 19.6604 15.8453V8.1547C19.6604 7.79744 19.4698 7.46731 19.1604 7.28868L12.5001 3.44338ZM10.5001 1.71133C11.4283 1.17543 12.5719 1.17543 13.5001 1.71133L20.1604 5.55663C21.0886 6.09252 21.6604 7.0829 21.6604 8.1547V15.8453C21.6604 16.9171 21.0886 17.9075 20.1604 18.4434L13.5001 22.2887C12.5719 22.8246 11.4283 22.8246 10.5001 22.2887L3.83984 18.4434C2.91164 17.9075 2.33984 16.9171 2.33984 15.8453V8.1547C2.33984 7.0829 2.91164 6.09252 3.83984 5.55663L10.5001 1.71133Z" fill="currentColor"></path><path d="M9.44133 11.4454L9.92944 9.98105C10.0321 9.67299 10.4679 9.67299 10.5706 9.98105L11.0587 11.4454C11.2941 12.1517 11.8483 12.7059 12.5546 12.9413L14.019 13.4294C14.327 13.5321 14.327 13.9679 14.019 14.0706L12.5546 14.5587C11.8483 14.7941 11.2941 15.3483 11.0587 16.0546L10.5706 17.519C10.4679 17.827 10.0321 17.827 9.92944 17.519L9.44133 16.0546C9.2059 15.3483 8.65167 14.7941 7.94537 14.5587L6.48105 14.0706C6.17298 13.9679 6.17298 13.5321 6.48105 13.4294L7.94537 12.9413C8.65167 12.7059 9.2059 12.1517 9.44133 11.4454Z" fill="currentColor"></path><path d="M14.4946 8.05961L14.7996 7.14441C14.8638 6.95187 15.1362 6.95187 15.2004 7.14441L15.5054 8.05961C15.6526 8.50104 15.999 8.84744 16.4404 8.99458L17.3556 9.29965C17.5481 9.36383 17.5481 9.63617 17.3556 9.70035L16.4404 10.0054C15.999 10.1526 15.6526 10.499 15.5054 10.9404L15.2004 11.8556C15.1362 12.0481 14.8638 12.0481 14.7996 11.8556L14.4946 10.9404C14.3474 10.499 14.001 10.1526 13.5596 10.0054L12.6444 9.70035C12.4519 9.63617 12.4519 9.36383 12.6444 9.29965L13.5596 8.99458C14.001 8.84744 14.3474 8.50104 14.4946 8.05961Z" fill="currentColor"></path></svg></i>
    <div className={styles.upgradePlanWrapper}  onClick={handleBackClick}>
    <span className={styles.upgradePlan}>Upgrade Plan</span>
    <span className={styles.moreModel}>More access to the best models</span>
    </div>
  </button> */}

        <Stack className={styles.chatHistoryListContainer}>
          {appStateContext?.state.chatHistoryLoadingState ===
            ChatHistoryLoadingState.Success &&
            appStateContext?.state.isCosmosDBAvailable.cosmosDB && (
              <div className={styles.sidebarListItem}>
                  <ChatHistoryList searchTerm={searchTerm} />
              </div>
            )}
          {appStateContext?.state.chatHistoryLoadingState ===
            ChatHistoryLoadingState.Fail &&
            appStateContext?.state.isCosmosDBAvailable && (
              <>
                <Stack>
                  <Stack
                    horizontalAlign="center"
                    verticalAlign="center"
                    style={{ width: "100%", marginTop: 10 }}
                  >
                    <StackItem>
                      <Text
                        style={{
                          alignSelf: "center",
                          fontWeight: "400",
                          fontSize: 16,
                        }}
                      >
                        {appStateContext?.state.isCosmosDBAvailable?.status && (
                          <span>
                            {appStateContext?.state.isCosmosDBAvailable?.status}
                          </span>
                        )}
                        {!appStateContext?.state.isCosmosDBAvailable
                          ?.status && <span>Error loading chat history</span>}
                      </Text>
                    </StackItem>
                    <StackItem>
                      <Text
                        style={{
                          alignSelf: "center",
                          fontWeight: "400",
                          fontSize: 14,
                        }}
                      >
                        <span>Chat history can't be saved at this time</span>
                      </Text>
                    </StackItem>
                  </Stack>
                </Stack>
              </>
            )}
          {/* {appStateContext?.state.chatHistoryLoadingState ===
            ChatHistoryLoadingState.Loading && (
            <>
              <Stack>
                <Stack
                  horizontal
                  horizontalAlign="center"
                  verticalAlign="center"
                  style={{ width: "100%", marginTop: 10 }}
                >
                  <StackItem
                    style={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <Spinner
                      style={{
                        alignSelf: "flex-start",
                        height: "100%",
                        marginRight: "5px",
                      }}
                      size={SpinnerSize.medium}
                    />
                  </StackItem>
                  <StackItem>
                    <Text
                      style={{
                        alignSelf: "center",
                        fontWeight: "400",
                        fontSize: 14,
                      }}
                    >
                      <span style={{ whiteSpace: "pre-wrap" }}>
                        Loading chat history
                      </span>
                    </Text>
                  </StackItem>
                </Stack>
              </Stack>
            </>
          )} */}
        </Stack>

{/* <div className={styles.expandCollapseWrapper}>
  <button  id="expand-collapse-icon" onClick={handleHistoryClick}
  data-tooltip-id="sidebar-tooltip"
  data-tooltip-content={sideBarEnable ? 'Expand' : 'Collapse '}>

    {sideBarEnable ? (
       // Expanded Sidebar Icon

      <i>
      <svg id="expandedIcon"
        width="24"
        height="24"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
<path d="M14.4254 2.42563C14.4254 1.98381 14.0671 1.62563 13.6254 1.62563H2.42539C1.98356 1.62563 1.62539 1.98381 1.62539 2.42563V13.6256C1.62539 14.0674 1.98357 14.4256 2.42539 14.4256H13.6254C14.0671 14.4256 14.4254 14.0674 14.4254 13.6256V2.42563ZM16.0254 13.6256C16.0254 14.951 14.9508 16.0256 13.6254 16.0256H2.42539C1.0999 16.0256 0.0253906 14.951 0.0253906 13.6256V2.42563C0.0253906 1.10015 1.09991 0.0256348 2.42539 0.0256348H13.6254C14.9508 0.0256348 16.0254 1.10014 16.0254 2.42563V13.6256Z" fill="#202939"/>
<path d="M4.8252 15.2256V0.825635C4.8252 0.383808 5.18337 0.0256348 5.6252 0.0256348C6.06702 0.0256348 6.4252 0.383808 6.4252 0.825635V15.2256C6.4252 15.6675 6.06702 16.0256 5.6252 16.0256C5.18337 16.0256 4.8252 15.6675 4.8252 15.2256Z" fill="#202939"/>
<path d="M9.06048 5.06011C9.35338 4.76722 9.81658 4.74915 10.1308 5.00543L10.1917 5.06011L12.5917 7.46011C12.7418 7.61014 12.8261 7.81357 12.8261 8.02574C12.8261 8.23791 12.7418 8.44134 12.5917 8.59136L10.1917 10.9914C9.87932 11.3038 9.3729 11.3038 9.06048 10.9914C8.74807 10.6789 8.74807 10.1725 9.06048 9.86011L10.8949 8.02574L9.06048 6.19136L9.0058 6.13043C8.74952 5.81621 8.76759 5.35301 9.06048 5.06011Z" fill="#202939"/>
</svg>
</i>


       

    ) : (
      <i>
     
      <svg id="collapsedIcon"
        width="24"
        height="24"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
<path d="M14.4254 2.45762C14.4254 2.0158 14.0671 1.65762 13.6254 1.65762H2.42539C1.98356 1.65762 1.62539 2.01579 1.62539 2.45762V13.6576C1.62539 14.0994 1.98357 14.4576 2.42539 14.4576H13.6254C14.0671 14.4576 14.4254 14.0994 14.4254 13.6576V2.45762ZM16.0254 13.6576C16.0254 14.983 14.9508 16.0576 13.6254 16.0576H2.42539C1.0999 16.0576 0.0253906 14.983 0.0253906 13.6576V2.45762C0.0253906 1.13213 1.09991 0.0576172 2.42539 0.0576172H13.6254C14.9508 0.0576172 16.0254 1.13213 16.0254 2.45762V13.6576Z" fill="#202939"/>
<path d="M4.8252 15.2576V0.857617C4.8252 0.415791 5.18337 0.0576172 5.6252 0.0576172C6.06702 0.0576172 6.4252 0.415791 6.4252 0.857617V15.2576C6.4252 15.6994 6.06702 16.0576 5.6252 16.0576C5.18337 16.0576 4.8252 15.6994 4.8252 15.2576Z" fill="#202939"/>
<path d="M12.5919 5.0921C12.299 4.79921 11.8358 4.78113 11.5215 5.03741L11.4606 5.0921L9.06061 7.4921C8.91058 7.64213 8.82623 7.84555 8.82623 8.05772C8.82623 8.2699 8.91058 8.47332 9.06061 8.62335L11.4606 11.0233C11.773 11.3358 12.2794 11.3358 12.5919 11.0233C12.9043 10.7109 12.9043 10.2045 12.5919 9.8921L10.7575 8.05772L12.5919 6.22335L12.6465 6.16241C12.9028 5.84819 12.8847 5.38499 12.5919 5.0921Z" fill="#202939"/>
</svg>
</i>


      
    )}

  </button>
</div> */}

{/* Tooltip component */}
<ReactTooltip
  id="sidebar-tooltip"
  place="right"
  className={styles.customTooltip}
/>
      </Stack>
      <Dialog
        hidden={hideClearAllDialog}
        onDismiss={clearing ? () => {} : onHideClearAllDialog}
        dialogContentProps={clearAllDialogContentProps}
        modalProps={modalProps}
      >
        <DialogFooter>
          {!clearingError && (
            <PrimaryButton
              onClick={onClearAllChatHistory}
              disabled={clearing}
              text="Clear All"
            />
          )}
          <DefaultButton
            onClick={onHideClearAllDialog}
            disabled={clearing}
            text={!clearingError ? "Cancel" : "Close"}
          />
        </DialogFooter>
      </Dialog>
    </section>
  );
}
